const brokerage = state => state;
const agentCity = state => state;

export default {
    brokerage,
    agentCity
};
